import request from '../request';

const getMovies = () =>
    request
        .get(`/movie`)
        .then((res) => res.json())
        .then((res) => res.docs);

export default getMovies;
